import { Bestellung, DateTimeCapsule, 
  Bezahlart, BuchungBestellart, Terminart,
  RemoteResult, BestellungInsertRequest,
  BuchungsartInsertRequest,
  IdRequest, TischMitFiliale
 } from "mangdto"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"

export default class TerminQrcodeLogic extends BaseLogic {
  filialeTisch?: TischMitFiliale = null
  wirdGebucht: boolean = false
  buchungsart: string = BuchungBestellart.Selbst
  showBuchungsart: boolean = false
  serviceWirdAngefordert: boolean = false

  init(id: string) {
    var request = new IdRequest()
    request.id = id

    Poster.postUser<RemoteResult<TischMitFiliale>>(
      RestPaths.tischMitFiliale,
      request
    ).then((response) => {
      if (response.data.success) {
        this.filialeTisch = response.data.payload
      }
    })
  }

  berechneBildId() {
    var filiale = this.filialeTisch.filiale
    if (filiale.bildId) {
      return RestPaths.urlBase + RestPaths.imageImage + "/" + filiale.bildId
    }
    return null
  }

  buchungsartWaehlen() {
    var request = new BuchungsartInsertRequest()
    request.id = store.state.user.identifier

    Poster.postUser<RemoteResult<DateTimeCapsule>>(
      RestPaths.bestellungKundeTischBuchungsartWaehlen,
      request
    ).then((response) => {
      if (response.data.success) {
        if (this.buchungsart == BuchungBestellart.Selbst) {
          router.push({ name: RouteNames.NEU.SHOPPING.PRODUKTE })
        } else if (this.buchungsart == BuchungBestellart.Service) {
          this.serviceWirdAngefordert = true
        }
      }
    })
  }

  tischBuchen() {
    this.wirdGebucht = true
    var request = new BestellungInsertRequest()
    request.terminart = Terminart.Sofortbestellung
    request.identifier = store.state.user.key
    request.filialeId = this.filialeTisch.filiale.filialeId
    request.bezahlart = Bezahlart.Barzahlung

    request.createSofortbestellung()
    request.sofort.bestellart = BuchungBestellart.Selbst
    request.sofort.personen = 2
    request.sofort.tischId = this.filialeTisch.tisch.id

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungKundeEinfuegen,
      request
    ).then((response) => {
      if (response.data.success) {
        this.wirdGebucht = false
        this.showBuchungsart = true
      }
    })
  }
}
